import { Flex, pxToNumber, SkeletonBox, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { formatIban } from '@features/bankAccounts/utils/formatIban'
import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'

import * as Styled from './styles'

interface BankConnectionProps {
  connectedBank?: OpenBankingAccount
  isLoading: boolean
  logoSize?: number
}

export const BankConnection = ({ connectedBank, isLoading, logoSize = 48 }: BankConnectionProps): ReactElement => {
  const containerHeight = logoSize + 2 * pxToNumber(Spacing.S16)
  if (isLoading) {
    return <SkeletonBox height={containerHeight} fullWidth />
  }

  const bankAccountName = connectedBank?.name
  const bankName = connectedBank?.bank?.name
  const bankAccountTitle = `${bankAccountName} ${formatIban(connectedBank?.iban, connectedBank?.currency)} ${connectedBank?.currency}`

  const bankLogoUrl = connectedBank?.bank?.presentation

  return (
    <Styled.BankConnectionWrapper>
      <Flex flexDirection="row" gap={Spacing.S16}>
        {bankLogoUrl && (
          <Styled.BankLogo src={bankLogoUrl} width={logoSize} height={logoSize} alt={bankName}></Styled.BankLogo>
        )}
        <Flex flexDirection="column">
          <Text weight="medium">{bankName}</Text>
          <Text>{bankAccountTitle}</Text>
        </Flex>
      </Flex>
    </Styled.BankConnectionWrapper>
  )
}
